<div class="ui placeholder" [style]="containerStyle$ | async">
  <div class="line" *ngFor="let _ of [].constructor(linesNumber)" [style]="style$ | async"></div>
</div>
